const AVATAR_COLORS = [
  "bg-blue-500",
  "bg-violet-500",
  "bg-rose-500",
  "bg-emerald-500",
  "bg-amber-500",
  "bg-cyan-500",
  "bg-indigo-500",
  "bg-pink-500",
  "bg-teal-500",
  "bg-orange-500",
  "bg-lime-600",
  "bg-sky-500",
];

function getAvatarColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function normalizeAvatarText(value: unknown): string {
  if (typeof value === "string") return value.trim();
  return "";
}

function normalizeAvatarSrc(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

function getInitials(name: string, lastName: string): string {
  const first = name[0]?.toUpperCase() ?? "";
  const last = lastName[0]?.toUpperCase() ?? "";
  return (first + last) || "?";
}

interface ContactAvatarProps {
  src?: string | null;
  name?: string | null;
  lastName?: string | null;
  className?: string;
  textClassName?: string;
  alt?: string;
}

export function ContactAvatar({
  src,
  name,
  lastName,
  className = "w-10 h-10 rounded-full",
  textClassName = "text-sm",
  alt,
}: ContactAvatarProps) {
  const normalizedSrc = normalizeAvatarSrc(src);
  const normalizedName = normalizeAvatarText(name);
  const normalizedLastName = normalizeAvatarText(lastName);
  const hasSrc = normalizedSrc !== "";
  const initials = getInitials(normalizedName, normalizedLastName);
  const colorClass = getAvatarColor(normalizedName + normalizedLastName);
  const fullName = `${normalizedName} ${normalizedLastName}`.trim();
  const accessibleName = alt ?? fullName;

  if (hasSrc) {
    return (
      <img
        src={normalizedSrc}
        alt={accessibleName}
        className={`object-cover flex-shrink-0 ${className}`}
      />
    );
  }

  return (
    <div
      className={`${colorClass} flex items-center justify-center text-white font-medium select-none flex-shrink-0 ${className}`}
      aria-label={accessibleName}
      role="img"
    >
      <span className={`${textClassName} leading-none`}>{initials}</span>
    </div>
  );
}
